module.exports = __webpack_public_path__ + "static/img/4.e2f4555.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/4.jpg
// module id = dNb9
// module chunks = 4